export var DEFAULT_TRADINGSESSION = '0930-1600';